import Axios from "axios";
import {
  SET_DEPARTMENT_PERFORMANCE_REPORT,
  UNSET_DEPARTMENT_PERFORMANCE_REPORT,
} from "@/store/mutation-types";
import {
  getDepartmentPerformanceReport,
} from "@/store/api";

const state = {
  departmentPerformanceReport: [],
};

const getters = {
  getDepartmentPerformanceReport(state) {
    return state.departmentPerformanceReport;
  },
};

const mutations = {
  [SET_DEPARTMENT_PERFORMANCE_REPORT](state, data) {
    state.departmentPerformanceReport = data;
  },
  [UNSET_DEPARTMENT_PERFORMANCE_REPORT](state) {
    state.departmentPerformanceReport = [];
  },
};

const actions = {
  getDepartmentPerformanceReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getDepartmentPerformanceReport}`, { params: data })
        .then((response) => {
          commit(SET_DEPARTMENT_PERFORMANCE_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_DEPARTMENT_PERFORMANCE_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

